module.exports = __webpack_public_path__ + "static/media/img1-3.3271663f.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/chile/nutricheck_foliar/FE/img1-3.png
// module id = 1471
// module chunks = 3